import { useEffect } from 'react'
import { LandingPageNumber, SummaryPageNumber } from '../constants'
import { useEdgeDataFindDuplicateOffer } from './useEdgeDataFetcher'

export default (landingContext, location) => {
  const { urlState, year, make, model, trim, trims, experienceState, globalState, offer, prospect, offerIsFetching, offerError, vinResults, vinIsFetching, plateStateVinError, vehicleIntoAuction } = landingContext
  const { isAdmin, dealerId, customerInfo, dealerInfo } = experienceState
  const { vin } = urlState //only urlState vin is valid vin
  const myprospect = prospect || (offer && offer.prospect)

  const isAddingVinToExisting = (isAdmin && vin && offer && offer.prospect && offer.prospect.vehicle && offer.prospect.vehicle.vin === '') || (offer && offer.quickQuote) // Needs to check existing prospect
  const needToCheckForDup = !offerIsFetching && !offerError && isAdmin && (!offer || isAddingVinToExisting) && !globalState.phoneError && !globalState.emailError
  const canCheckForDup = needToCheckForDup && vin && year && make && model && (trim || (vin && trims && trims[0])) && true //if vin is present just use default trim

  const getRequestBody = () => {
    const { yearId } = year
    const { makeId } = make
    const { modelId } = model
    const { trimId } = trim || (vin && trims && trims[0])
    const bodyId = trimId
    const email = globalState.email || customerInfo.email || (myprospect && myprospect.contactInfo ? myprospect.contactInfo.email || '' : '')
    const phone = globalState.phone || customerInfo.phone || (myprospect && myprospect.contactInfo ? myprospect.contactInfo.phone || '' : '')
    const isConsumerOffer = (dealerInfo && dealerInfo.isConsumerOffer) || (myprospect && myprospect.isConsumerOffer) ? true : false
    const requestBody = { dealerId, vin, yearId, makeId, modelId, bodyId, trimId, email, phone, isConsumerOffer }
    if (requestBody.phone && requestBody.phone.length > 0) requestBody.phone = requestBody.phone.replace(/\+1|\(|\)| |-/gi, '')
    return requestBody
  }
  const [duplicateOffers, , duplicateOffersIsFetching] = useEdgeDataFindDuplicateOffer(canCheckForDup && getRequestBody())
  landingContext.setLoadingInfo('Checking Duplicate Offers', duplicateOffersIsFetching)

  if (duplicateOffers && duplicateOffers.length > 0 && (!offer || (offer && duplicateOffers[0].offerId !== offer.offerId))) landingContext.duplicateInfo = duplicateOffers[0]

  useEffect(() => {
    if (needToCheckForDup && !duplicateOffersIsFetching && urlState.p > LandingPageNumber && (!canCheckForDup || !duplicateOffers || landingContext.duplicateInfo)) {
      urlState.p = LandingPageNumber
      urlState.pp = (urlState.pp || 0) + 1
    }
  }, [needToCheckForDup, duplicateOffersIsFetching, urlState.p, canCheckForDup, duplicateOffers, landingContext.duplicateInfo])

  if (isAdmin && myprospect && !location.initPathParams.find(x => x === 'offer')) {
    const vinToUse = vin || (myprospect.vehicle && myprospect.vehicle.vin)
    const vinIndex = myprospect.vehicle && vinResults && vinResults.trims && vinResults.trims.findIndex(trim => +trim.trimId === +myprospect.vehicle.trimId)
    const misMatch = vinIndex === -1
    const vinResultsExists = !!vinResults
    const vinModal = (!vinToUse || vinResultsExists || plateStateVinError) && (!vinResults || misMatch || vehicleIntoAuction) && !globalState.resetTrim
    const vinCheck = (!vinToUse || vinResultsExists || vinIsFetching) && misMatch && !globalState.resetTrim
    //vinModal controls whether the vin required modal should show
    //vinCheck is used to have edge calls (like patch prospect) wait until the vin check has come back and matches
    //misMatch represents a vindecode that does not match the current trim/vin
    landingContext.vinModalInfo = { vinModal, vinCheck, misMatch }
  } else landingContext.vinModalInfo = {}
  if (urlState.p !== SummaryPageNumber && urlState.p !== LandingPageNumber && landingContext.vinModalInfo.vinCheck && !globalState.resetTrim) {
    urlState.p = LandingPageNumber
    urlState.pp = (urlState.pp || 0) + 1
  }

  if (!!needToCheckForDup && !duplicateOffersIsFetching) landingContext.determineVinOptionChanges()
}
